"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicLensFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TectonicCoreLensInterface",
                name: "tectonicCore",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getAccountLimits",
        outputs: [
            {
                components: [
                    {
                        internalType: "contract TToken[]",
                        name: "markets",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256",
                        name: "liquidity",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "shortfall",
                        type: "uint256",
                    },
                ],
                internalType: "struct TectonicLens.AccountLimits",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "contract GovernorBravoInterface",
                name: "governor",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
        ],
        name: "getGovBravoProposals",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "proposalId",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "proposer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "eta",
                        type: "uint256",
                    },
                    {
                        internalType: "address[]",
                        name: "targets",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "values",
                        type: "uint256[]",
                    },
                    {
                        internalType: "string[]",
                        name: "signatures",
                        type: "string[]",
                    },
                    {
                        internalType: "bytes[]",
                        name: "calldatas",
                        type: "bytes[]",
                    },
                    {
                        internalType: "uint256",
                        name: "startBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "forVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "againstVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "abstainVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "canceled",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "executed",
                        type: "bool",
                    },
                ],
                internalType: "struct TectonicLens.GovBravoProposal[]",
                name: "",
                type: "tuple[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "contract GovernorBravoInterface",
                name: "governor",
                type: "address",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
        ],
        name: "getGovBravoReceipts",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "proposalId",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "uint8",
                        name: "support",
                        type: "uint8",
                    },
                    {
                        internalType: "uint128",
                        name: "votes",
                        type: "uint128",
                    },
                ],
                internalType: "struct TectonicLens.GovBravoReceipt[]",
                name: "",
                type: "tuple[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "contract GovernorAlpha",
                name: "governor",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
        ],
        name: "getGovProposals",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "proposalId",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "proposer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "eta",
                        type: "uint256",
                    },
                    {
                        internalType: "address[]",
                        name: "targets",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "values",
                        type: "uint256[]",
                    },
                    {
                        internalType: "string[]",
                        name: "signatures",
                        type: "string[]",
                    },
                    {
                        internalType: "bytes[]",
                        name: "calldatas",
                        type: "bytes[]",
                    },
                    {
                        internalType: "uint256",
                        name: "startBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "forVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "againstVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "canceled",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "executed",
                        type: "bool",
                    },
                ],
                internalType: "struct TectonicLens.GovProposal[]",
                name: "",
                type: "tuple[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "contract GovernorAlpha",
                name: "governor",
                type: "address",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
        ],
        name: "getGovReceipts",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "proposalId",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "support",
                        type: "bool",
                    },
                    {
                        internalType: "uint128",
                        name: "votes",
                        type: "uint128",
                    },
                ],
                internalType: "struct TectonicLens.GovReceipt[]",
                name: "",
                type: "tuple[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "contract Tonic",
                name: "tonic",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getTonicBalanceMetadata",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "balance",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "votes",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "delegate",
                        type: "address",
                    },
                ],
                internalType: "struct TectonicLens.TonicBalanceMetadata",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract Tonic",
                name: "tonic",
                type: "address",
            },
            {
                internalType: "contract TectonicCoreLensInterface",
                name: "tectonicCore",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getTonicBalanceMetadataExt",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "balance",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "votes",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "delegate",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "allocated",
                        type: "uint256",
                    },
                ],
                internalType: "struct TectonicLens.TonicBalanceMetadataExt",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "contract Tonic",
                name: "tonic",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint32[]",
                name: "blockNumbers",
                type: "uint32[]",
            },
        ],
        name: "getTonicVotes",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "blockNumber",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "votes",
                        type: "uint256",
                    },
                ],
                internalType: "struct TectonicLens.TonicVotes[]",
                name: "",
                type: "tuple[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "account",
                type: "address",
            },
        ],
        name: "tTokenBalances",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "tToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "balanceOf",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "borrowBalanceCurrent",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "balanceOfUnderlying",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenBalance",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenAllowance",
                        type: "uint256",
                    },
                ],
                internalType: "struct TectonicLens.TTokenBalances",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken[]",
                name: "tTokens",
                type: "address[]",
            },
            {
                internalType: "address payable",
                name: "account",
                type: "address",
            },
        ],
        name: "tTokenBalancesAll",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "tToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "balanceOf",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "borrowBalanceCurrent",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "balanceOfUnderlying",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenBalance",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenAllowance",
                        type: "uint256",
                    },
                ],
                internalType: "struct TectonicLens.TTokenBalances[]",
                name: "",
                type: "tuple[]",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
        ],
        name: "tTokenMetadata",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "tToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "exchangeRateCurrent",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "supplyRatePerBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "borrowRatePerBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "reserveFactorMantissa",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalBorrows",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalReserves",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalCash",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "isListed",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "collateralFactorMantissa",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "underlyingAssetAddress",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "tTokenDecimals",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "underlyingDecimals",
                        type: "uint256",
                    },
                ],
                internalType: "struct TectonicLens.TTokenMetadata",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken[]",
                name: "tTokens",
                type: "address[]",
            },
        ],
        name: "tTokenMetadataAll",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "tToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "exchangeRateCurrent",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "supplyRatePerBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "borrowRatePerBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "reserveFactorMantissa",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalBorrows",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalReserves",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalCash",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "isListed",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "collateralFactorMantissa",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "underlyingAssetAddress",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "tTokenDecimals",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "underlyingDecimals",
                        type: "uint256",
                    },
                ],
                internalType: "struct TectonicLens.TTokenMetadata[]",
                name: "",
                type: "tuple[]",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
        ],
        name: "tTokenUnderlyingPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "tToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "underlyingPrice",
                        type: "uint256",
                    },
                ],
                internalType: "struct TectonicLens.TTokenUnderlyingPrice",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken[]",
                name: "tTokens",
                type: "address[]",
            },
        ],
        name: "tTokenUnderlyingPriceAll",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "tToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "underlyingPrice",
                        type: "uint256",
                    },
                ],
                internalType: "struct TectonicLens.TTokenUnderlyingPrice[]",
                name: "",
                type: "tuple[]",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50613d80806100206000396000f3fe608060405234801561001057600080fd5b50600436106100ba5760003560e01c8063127a0362146100bf57806343c811cc146100e8578063558e18c41461010857806375d80e901461012857806376b4e3a4146101485780637dd8f6d9146101685780639699486914610188578063995ed99f146101a8578063bcf88a87146101c8578063be77b99e146101e8578063c118574914610208578063c950cded14610228578063d401424c14610248578063f2b3d46314610268575b600080fd5b6100d26100cd366004612a09565b610288565b6040516100df9190613b36565b60405180910390f35b6100fb6100f6366004612b0c565b610324565b6040516100df9190613ae1565b61011b610116366004612c8e565b61048b565b6040516100df9190613ba2565b61013b610136366004612b66565b6107a2565b6040516100df9190613ad0565b61015b610156366004612a09565b610965565b6040516100df9190613b25565b61017b610176366004612bf7565b6109f6565b6040516100df9190613b66565b61019b610196366004612b66565b610b32565b6040516100df9190613af2565b6101bb6101b6366004612b0c565b610ce5565b6040516100df9190613b03565b6101db6101d6366004612bd9565b610e3f565b6040516100df9190613b85565b6101fb6101f6366004612a4a565b6115c3565b6040516100df9190613b14565b61021b610216366004612bf7565b61165a565b6040516100df9190613b77565b61023b610236366004612bf7565b6119fa565b6040516100df9190613bb0565b61025b610256366004612bd9565b611ba3565b6040516100df9190613b94565b61027b610276366004612c27565b611d35565b6040516100df9190613b47565b604080518281526020808402820101909152606090829082908280156102c857816020015b6102b561210f565b8152602001906001900390816102ad5790505b50905060005b82811015610319576102fa8686838181106102e557fe5b90506020020160206102569190810190612bd9565b82828151811061030657fe5b60209081029190910101526001016102ce565b509150505b92915050565b606060008251905060608160405190808252806020026020018201604052801561036857816020015b610355612126565b81526020019060019003908161034d5790505b50905060005b8281101561047f5761037e61214d565b876001600160a01b031663e23a9a5287848151811061039957fe5b6020026020010151896040518363ffffffff1660e01b81526004016103bf929190613bcc565b60606040518083038186803b1580156103d757600080fd5b505afa1580156103eb573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525061040f9190810190612d42565b9050604051806080016040528087848151811061042857fe5b60200260200101518152602001826000015115158152602001826020015160ff16815260200182604001516001600160801b031681525083838151811061046b57fe5b60209081029190910101525060010161036e565b509150505b9392505050565b61049361216d565b6040516370a0823160e01b81526000906001600160a01b038616906370a08231906104c2908690600401613a5e565b60206040518083038186803b1580156104da57600080fd5b505afa1580156104ee573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506105129190810190612d7e565b90506060846001600160a01b031663b0772d0b6040518163ffffffff1660e01b815260040160006040518083038186803b15801561054f57600080fd5b505afa158015610563573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261058b9190810190612a9e565b6040516319b6e98b60e31b81529091506001600160a01b0386169063cdb74c58906105bc9087908590600401613a95565b600060405180830381600087803b1580156105d657600080fd5b505af11580156105ea573d6000803e3d6000fd5b505060405163336e971960e11b8152600092506001600160a01b03881691506366dd2e329061061d908890600401613a5e565b60206040518083038186803b15801561063557600080fd5b505afa158015610649573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525061066d9190810190612d7e565b90506040518060800160405280848152602001886001600160a01b031663b4b5ea57886040518263ffffffff1660e01b81526004016106ac9190613a5e565b60206040518083038186803b1580156106c457600080fd5b505afa1580156106d8573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506106fc9190810190612d60565b6001600160801b03168152602001886001600160a01b031663587cde1e886040518263ffffffff1660e01b81526004016107369190613a5e565b60206040518083038186803b15801561074e57600080fd5b505afa158015610762573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506107869190810190612927565b6001600160a01b03168152602001919091529695505050505050565b606080838390506040519080825280602002602001820160405280156107e257816020015b6107cf61219e565b8152602001906001900390816107c75790505b50905060005b8381101561095c57606080606080896001600160a01b031663328dd9828a8a8881811061081157fe5b905060200201356040518263ffffffff1660e01b81526004016108349190613bbe565b60006040518083038186803b15801561084c57600080fd5b505afa158015610860573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610888919081019061294d565b9350935093509350604051806101c001604052806000815260200160006001600160a01b031681526020016000815260200185815260200184815260200183815260200182815260200160008152602001600081526020016000815260200160008152602001600081526020016000151581526020016000151581525086868151811061091157fe5b602002602001018190525061094c86868151811061092b57fe5b60200260200101518b8b8b8981811061094057fe5b90506020020135611e8d565b5050600190920191506107e89050565b50949350505050565b604080518281526020808402820101909152606090829082908280156109a557816020015b61099261221a565b81526020019060019003908161098a5790505b50905060005b82811015610319576109d78686838181106109c257fe5b90506020020160206101d69190810190612bd9565b8282815181106109e357fe5b60209081029190910101526001016109ab565b6109fe61229d565b6000806000856001600160a01b0316635ec88c79866040518263ffffffff1660e01b8152600401610a2f9190613a5e565b60606040518083038186803b158015610a4757600080fd5b505afa158015610a5b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250610a7f9190810190612e60565b92509250925082600014610a9257600080fd5b604080516060810191829052632aff3bff60e21b909152806001600160a01b03881663abfceffc610ac68960648501613a5e565b60006040518083038186803b158015610ade57600080fd5b505afa158015610af2573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610b1a9190810190612a9e565b81526020810193909352604090920152949350505050565b60608083839050604051908082528060200260200182016040528015610b7257816020015b610b5f6122be565b815260200190600190039081610b575790505b50905060005b8381101561095c57606080606080896001600160a01b031663328dd9828a8a88818110610ba157fe5b905060200201356040518263ffffffff1660e01b8152600401610bc49190613bbe565b60006040518083038186803b158015610bdc57600080fd5b505afa158015610bf0573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610c18919081019061294d565b9350935093509350604051806101a001604052806000815260200160006001600160a01b03168152602001600081526020018581526020018481526020018381526020018281526020016000815260200160008152602001600081526020016000815260200160001515815260200160001515815250868681518110610c9a57fe5b6020026020010181905250610cd5868681518110610cb457fe5b60200260200101518b8b8b89818110610cc957fe5b90506020020135611f90565b505060019092019150610b789050565b6060600082519050606081604051908082528060200260200182016040528015610d2957816020015b610d16612126565b815260200190600190039081610d0e5790505b50905060005b8281101561047f57610d3f61214d565b876001600160a01b031663e23a9a52878481518110610d5a57fe5b6020026020010151896040518363ffffffff1660e01b8152600401610d80929190613bcc565b60606040518083038186803b158015610d9857600080fd5b505afa158015610dac573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250610dd09190810190612d24565b90506040518060800160405280878481518110610de957fe5b6020026020010151815260200182600001511515815260200182602001511515815260200182604001516001600160801b0316815250838381518110610e2b57fe5b602090810291909101015250600101610d2f565b610e4761221a565b6000826001600160a01b031663bd6d894d6040518163ffffffff1660e01b8152600401602060405180830381600087803b158015610e8457600080fd5b505af1158015610e98573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250610ebc9190810190612d7e565b90506000836001600160a01b031663c16a61ec6040518163ffffffff1660e01b815260040160206040518083038186803b158015610ef957600080fd5b505afa158015610f0d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250610f319190810190612bbb565b9050600080826001600160a01b0316638e8f294b876040518263ffffffff1660e01b8152600401610f629190613a5e565b604080518083038186803b158015610f7957600080fd5b505afa158015610f8d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250610fb19190810190612ad2565b91509150600080611052886001600160a01b03166395d89b416040518163ffffffff1660e01b815260040160006040518083038186803b158015610ff457600080fd5b505afa158015611008573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526110309190810190612cd1565b604051806040016040528060048152602001630e88aa8960e31b8152506120b6565b1561106357506000905060126111c3565b6000889050806001600160a01b0316636f307dc36040518163ffffffff1660e01b815260040160206040518083038186803b1580156110a157600080fd5b505afa1580156110b5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506110d99190810190612927565b9250806001600160a01b0316636f307dc36040518163ffffffff1660e01b815260040160206040518083038186803b15801561111457600080fd5b505afa158015611128573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525061114c9190810190612927565b6001600160a01b031663313ce5676040518163ffffffff1660e01b815260040160206040518083038186803b15801561118457600080fd5b505afa158015611198573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506111bc9190810190612ec1565b60ff169150505b604051806101c00160405280896001600160a01b03168152602001878152602001896001600160a01b031663ae9d70b06040518163ffffffff1660e01b815260040160206040518083038186803b15801561121d57600080fd5b505afa158015611231573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506112559190810190612d7e565b8152602001896001600160a01b031663f8f9da286040518163ffffffff1660e01b815260040160206040518083038186803b15801561129357600080fd5b505afa1580156112a7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506112cb9190810190612d7e565b8152602001896001600160a01b031663173b99046040518163ffffffff1660e01b815260040160206040518083038186803b15801561130957600080fd5b505afa15801561131d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506113419190810190612d7e565b8152602001896001600160a01b03166347bd37186040518163ffffffff1660e01b815260040160206040518083038186803b15801561137f57600080fd5b505afa158015611393573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506113b79190810190612d7e565b8152602001896001600160a01b0316638f840ddd6040518163ffffffff1660e01b815260040160206040518083038186803b1580156113f557600080fd5b505afa158015611409573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525061142d9190810190612d7e565b8152602001896001600160a01b03166318160ddd6040518163ffffffff1660e01b815260040160206040518083038186803b15801561146b57600080fd5b505afa15801561147f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506114a39190810190612d7e565b8152602001896001600160a01b0316633b1d21a26040518163ffffffff1660e01b815260040160206040518083038186803b1580156114e157600080fd5b505afa1580156114f5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506115199190810190612d7e565b81526020018515158152602001848152602001836001600160a01b03168152602001896001600160a01b031663313ce5676040518163ffffffff1660e01b815260040160206040518083038186803b15801561157457600080fd5b505afa158015611588573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506115ac9190810190612ec1565b60ff16815260200191909152979650505050505050565b6040805183815260208085028201019091526060908390829082801561160357816020015b6115f0612333565b8152602001906001900390816115e85790505b50905060005b8281101561047f5761163b87878381811061162057fe5b90506020020160206116359190810190612bd9565b8661165a565b82828151811061164757fe5b6020908102919091010152600101611609565b611662612333565b6040516370a0823160e01b81526000906001600160a01b038516906370a0823190611691908690600401613a6c565b60206040518083038186803b1580156116a957600080fd5b505afa1580156116bd573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506116e19190810190612d7e565b90506000846001600160a01b03166317bfdfbc856040518263ffffffff1660e01b81526004016117119190613a6c565b602060405180830381600087803b15801561172b57600080fd5b505af115801561173f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506117639190810190612d7e565b90506000856001600160a01b0316633af9e669866040518263ffffffff1660e01b81526004016117939190613a6c565b602060405180830381600087803b1580156117ad57600080fd5b505af11580156117c1573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506117e59190810190612d7e565b9050600080611826886001600160a01b03166395d89b416040518163ffffffff1660e01b815260040160006040518083038186803b158015610ff457600080fd5b156118405750506001600160a01b038516803190316119bd565b60008890506000816001600160a01b0316636f307dc36040518163ffffffff1660e01b815260040160206040518083038186803b15801561188057600080fd5b505afa158015611894573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506118b89190810190612927565b6040516370a0823160e01b81529091506001600160a01b038216906370a08231906118e7908c90600401613a6c565b60206040518083038186803b1580156118ff57600080fd5b505afa158015611913573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506119379190810190612d7e565b604051636eb1769f60e11b81529094506001600160a01b0382169063dd62ed3e90611968908c908e90600401613a7a565b60206040518083038186803b15801561198057600080fd5b505afa158015611994573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506119b89190810190612d7e565b925050505b6040805160c0810182526001600160a01b039990991689526020890195909552938701929092526060860152608085015260a08401525090919050565b611a02612372565b6040805160608101918290526370a0823160e01b909152806001600160a01b0385166370a08231611a368660648501613a5e565b60206040518083038186803b158015611a4e57600080fd5b505afa158015611a62573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250611a869190810190612d7e565b8152602001846001600160a01b031663b4b5ea57856040518263ffffffff1660e01b8152600401611ab79190613a5e565b60206040518083038186803b158015611acf57600080fd5b505afa158015611ae3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250611b079190810190612d60565b6001600160801b03168152602001846001600160a01b031663587cde1e856040518263ffffffff1660e01b8152600401611b419190613a5e565b60206040518083038186803b158015611b5957600080fd5b505afa158015611b6d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250611b919190810190612927565b6001600160a01b031690529392505050565b611bab61210f565b6000826001600160a01b031663c16a61ec6040518163ffffffff1660e01b815260040160206040518083038186803b158015611be657600080fd5b505afa158015611bfa573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250611c1e9190810190612bbb565b90506000816001600160a01b0316637dc0d1d06040518163ffffffff1660e01b815260040160206040518083038186803b158015611c5b57600080fd5b505afa158015611c6f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250611c939190810190612bbb565b90506040518060400160405280856001600160a01b03168152602001826001600160a01b031663fc57d4df876040518263ffffffff1660e01b8152600401611cdb9190613b58565b60206040518083038186803b158015611cf357600080fd5b505afa158015611d07573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250611d2b9190810190612d7e565b9052949350505050565b60608083839050604051908082528060200260200182016040528015611d7557816020015b611d6261239c565b815260200190600190039081611d5a5790505b50905060005b83811015611e83576040518060400160405280868684818110611d9a57fe5b9050602002016020611daf9190810190612ea3565b63ffffffff168152602001886001600160a01b031663782d6fe189898987818110611dd657fe5b9050602002016020611deb9190810190612ea3565b6040518363ffffffff1660e01b8152600401611e08929190613ab5565b60206040518083038186803b158015611e2057600080fd5b505afa158015611e34573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250611e589190810190612d60565b6001600160801b0316815250828281518110611e7057fe5b6020908102919091010152600101611d7b565b5095945050505050565b611e956123b6565b60405163013cf08b60e01b81526001600160a01b0384169063013cf08b90611ec1908590600401613bbe565b6101406040518083038186803b158015611eda57600080fd5b505afa158015611eee573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250611f129190810190612d05565b918452506020808201516001600160a01b03169084015260408082015190840152606081015160e08085019190915260808201516101008086019190915260a08301516101208087019190915260c0840151610140870152918301516101608601528201511515610180850152015115156101a09092019190915250565b600080600080600080600080896001600160a01b031663013cf08b8a6040518263ffffffff1660e01b8152600401611fc89190613bbe565b6101206040518083038186803b158015611fe157600080fd5b505afa158015611ff5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506120199190810190612d9c565b9850985098509850985098509850985050888b6000018181525050878b602001906001600160a01b031690816001600160a01b031681525050868b6040018181525050858b60e0018181525050848b610100018181525050838b610120018181525050828b610140018181525050818b610160019015159081151581525050808b6101800190151590811515815250505050505050505050505050565b6000816040516020016120c99190613a52565b60405160208183030381529060405280519060200120836040516020016120f09190613a52565b6040516020818303038152906040528051906020012014905092915050565b604080518082019091526000808252602082015290565b60408051608081018252600080825260208201819052918101829052606081019190915290565b604080516060810182526000808252602082018190529181019190915290565b6040518060800160405280600081526020016000815260200160006001600160a01b03168152602001600081525090565b604051806101c001604052806000815260200160006001600160a01b03168152602001600081526020016060815260200160608152602001606081526020016060815260200160008152602001600081526020016000815260200160008152602001600081526020016000151581526020016000151581525090565b604051806101c0016040528060006001600160a01b0316815260200160008152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081526020016000151581526020016000815260200160006001600160a01b0316815260200160008152602001600081525090565b60405180606001604052806060815260200160008152602001600081525090565b604051806101a001604052806000815260200160006001600160a01b031681526020016000815260200160608152602001606081526020016060815260200160608152602001600081526020016000815260200160008152602001600081526020016000151581526020016000151581525090565b6040518060c0016040528060006001600160a01b0316815260200160008152602001600081526020016000815260200160008152602001600081525090565b6040518060600160405280600081526020016000815260200160006001600160a01b031681525090565b604051806040016040528060008152602001600081525090565b6040518061014001604052806000815260200160006001600160a01b031681526020016000815260200160008152602001600081526020016000815260200160008152602001600081526020016000151581526020016000151581525090565b803561031e81613cf0565b805161031e81613cf0565b600082601f83011261243d57600080fd5b815161245061244b82613c00565b613bda565b9150818183526020840193506020810190508385602084028201111561247557600080fd5b60005b838110156124a1578161248b8882612421565b8452506020928301929190910190600101612478565b5050505092915050565b600082601f8301126124bc57600080fd5b81516124ca61244b82613c00565b81815260209384019390925082018360005b838110156124a157815186016124f28882612708565b84525060209283019291909101906001016124dc565b60008083601f84011261251a57600080fd5b5081356001600160401b0381111561253157600080fd5b60208301915083602082028301111561254957600080fd5b9250929050565b600082601f83011261256157600080fd5b815161256f61244b82613c00565b9150818183526020840193506020810190508385602084028201111561259457600080fd5b60005b838110156124a157816125aa8882612762565b8452506020928301929190910190600101612597565b600082601f8301126125d157600080fd5b81516125df61244b82613c00565b81815260209384019390925082018360005b838110156124a157815186016126078882612708565b84525060209283019291909101906001016125f1565b600082601f83011261262e57600080fd5b813561263c61244b82613c00565b9150818183526020840193506020810190508385602084028201111561266157600080fd5b60005b838110156124a1578161267788826128fb565b8452506020928301929190910190600101612664565b600082601f83011261269e57600080fd5b81516126ac61244b82613c00565b915081818352602084019350602081019050838560208402820111156126d157600080fd5b60005b838110156124a157816126e78882612906565b84525060209283019291909101906001016126d4565b805161031e81613d07565b600082601f83011261271957600080fd5b815161272761244b82613c20565b9150808252602083016020830185838301111561274357600080fd5b61274e838284613cba565b50505092915050565b803561031e81613d10565b805161031e81613d10565b6000610140828403121561278057600080fd5b61278b610140613bda565b905060006127998484612906565b82525060206127aa84848301612421565b60208301525060406127be84828501612906565b60408301525060606127d284828501612906565b60608301525060806127e684828501612906565b60808301525060a06127fa84828501612906565b60a08301525060c061280e84828501612906565b60c08301525060e061282284828501612906565b60e083015250610100612837848285016126fd565b6101008301525061012061284d848285016126fd565b6101208301525092915050565b60006060828403121561286c57600080fd5b6128766060613bda565b9050600061288484846126fd565b8252506020612895848483016126fd565b60208301525060406128a9848285016128f0565b60408301525092915050565b6000606082840312156128c757600080fd5b6128d16060613bda565b905060006128df84846126fd565b82525060206128958484830161291c565b805161031e81613d19565b803561031e81613d22565b805161031e81613d22565b803561031e81613d2b565b805161031e81613d34565b60006020828403121561293957600080fd5b60006129458484612421565b949350505050565b6000806000806080858703121561296357600080fd5b84516001600160401b0381111561297957600080fd5b6129858782880161242c565b94505060208501516001600160401b038111156129a157600080fd5b6129ad8782880161268d565b93505060408501516001600160401b038111156129c957600080fd5b6129d5878288016125c0565b92505060608501516001600160401b038111156129f157600080fd5b6129fd878288016124ab565b91505092959194509250565b60008060208385031215612a1c57600080fd5b82356001600160401b03811115612a3257600080fd5b612a3e85828601612508565b92509250509250929050565b600080600060408486031215612a5f57600080fd5b83356001600160401b03811115612a7557600080fd5b612a8186828701612508565b93509350506020612a9486828701612416565b9150509250925092565b600060208284031215612ab057600080fd5b81516001600160401b03811115612ac657600080fd5b61294584828501612550565b60008060408385031215612ae557600080fd5b6000612af185856126fd565b9250506020612b0285828601612906565b9150509250929050565b600080600060608486031215612b2157600080fd5b6000612b2d8686612757565b9350506020612b3e86828701612416565b92505060408401356001600160401b03811115612b5a57600080fd5b612a948682870161261d565b600080600060408486031215612b7b57600080fd5b6000612b878686612757565b93505060208401356001600160401b03811115612ba357600080fd5b612baf86828701612508565b92509250509250925092565b600060208284031215612bcd57600080fd5b60006129458484612762565b600060208284031215612beb57600080fd5b60006129458484612757565b60008060408385031215612c0a57600080fd5b6000612c168585612757565b9250506020612b0285828601612416565b60008060008060608587031215612c3d57600080fd5b6000612c498787612757565b9450506020612c5a87828801612416565b93505060408501356001600160401b03811115612c7657600080fd5b612c8287828801612508565b95989497509550505050565b600080600060608486031215612ca357600080fd5b6000612caf8686612757565b9350506020612cc086828701612757565b9250506040612a9486828701612416565b600060208284031215612ce357600080fd5b81516001600160401b03811115612cf957600080fd5b61294584828501612708565b60006101408284031215612d1857600080fd5b6000612945848461276d565b600060608284031215612d3657600080fd5b6000612945848461285a565b600060608284031215612d5457600080fd5b600061294584846128b5565b600060208284031215612d7257600080fd5b600061294584846128f0565b600060208284031215612d9057600080fd5b60006129458484612906565b60008060008060008060008060006101208a8c031215612dbb57600080fd5b6000612dc78c8c612906565b9950506020612dd88c828d01612421565b9850506040612de98c828d01612906565b9750506060612dfa8c828d01612906565b9650506080612e0b8c828d01612906565b95505060a0612e1c8c828d01612906565b94505060c0612e2d8c828d01612906565b93505060e0612e3e8c828d016126fd565b925050610100612e508c828d016126fd565b9150509295985092959850929598565b600080600060608486031215612e7557600080fd5b6000612e818686612906565b9350506020612e9286828701612906565b9250506040612a9486828701612906565b600060208284031215612eb557600080fd5b60006129458484612911565b600060208284031215612ed357600080fd5b6000612945848461291c565b6000612eeb8383612fa7565b505060200190565b60006104848383613461565b6000612eeb8383613499565b60006104848383613519565b6000612f23838361364d565b505060800190565b6000610484838361369d565b6000612f2383836137bc565b6000612f4f83836137f3565b505060c00190565b6000612f638383613863565b50506101c00190565b6000612f788383613978565b505060400190565b6000612f788383613a1d565b6000612eeb8383613a37565b612fa181613ca4565b82525050565b612fa181613c5f565b6000612fbb82613c4d565b612fc58185613c51565b9350612fd083613c47565b8060005b83811015612ffe578151612fe88882612edf565b9750612ff383613c47565b925050600101612fd4565b509495945050505050565b600061301482613c4d565b61301e8185613c51565b93508360208202850161303085613c47565b8060005b8581101561306a578484038952815161304d8582612ef3565b945061305883613c47565b60209a909a0199925050600101613034565b5091979650505050505050565b600061308282613c4d565b61308c8185613c51565b935061309783613c47565b8060005b83811015612ffe5781516130af8882612eff565b97506130ba83613c47565b92505060010161309b565b60006130d082613c4d565b6130da8185613c51565b93506130e583613c47565b8060005b83811015612ffe5781516130fd8882612eff565b975061310883613c47565b9250506001016130e9565b600061311e82613c4d565b6131288185613c51565b93508360208202850161313a85613c47565b8060005b8581101561306a57848403895281516131578582612ef3565b945061316283613c47565b60209a909a019992505060010161313e565b600061317f82613c4d565b6131898185613c51565b93508360208202850161319b85613c47565b8060005b8581101561306a57848403895281516131b88582612f0b565b94506131c383613c47565b60209a909a019992505060010161319f565b60006131e082613c4d565b6131ea8185613c51565b93506131f583613c47565b8060005b83811015612ffe57815161320d8882612f17565b975061321883613c47565b9250506001016131f9565b600061322e82613c4d565b6132388185613c51565b93508360208202850161324a85613c47565b8060005b8581101561306a57848403895281516132678582612f2b565b945061327283613c47565b60209a909a019992505060010161324e565b600061328f82613c4d565b6132998185613c51565b93506132a483613c47565b8060005b83811015612ffe5781516132bc8882612f37565b97506132c783613c47565b9250506001016132a8565b60006132dd82613c4d565b6132e78185613c51565b93506132f283613c47565b8060005b83811015612ffe57815161330a8882612f43565b975061331583613c47565b9250506001016132f6565b600061332b82613c4d565b6133358185613c51565b935061334083613c47565b8060005b83811015612ffe5781516133588882612f57565b975061336383613c47565b925050600101613344565b600061337982613c4d565b6133838185613c51565b935061338e83613c47565b8060005b83811015612ffe5781516133a68882612f6c565b97506133b183613c47565b925050600101613392565b60006133c782613c4d565b6133d18185613c51565b93506133dc83613c47565b8060005b83811015612ffe5781516133f48882612f80565b97506133ff83613c47565b9250506001016133e0565b600061341582613c4d565b61341f8185613c51565b935061342a83613c47565b8060005b83811015612ffe5781516134428882612f8c565b975061344d83613c47565b92505060010161342e565b612fa181613c6a565b600061346c82613c4d565b6134768185613c51565b9350613486818560208601613cba565b61348f81613ce6565b9093019392505050565b612fa181613c6f565b60006134ad82613c4d565b6134b78185613c5a565b93506134c7818560208601613cba565b9290920192915050565b80516060808452600091908401906134e982826130c5565b91505060208301516134fe6020860182613a37565b5060408301516135116040860182613a37565b509392505050565b80516000906101c084019061352e8582613a37565b5060208301516135416020860182612fa7565b5060408301516135546040860182613a37565b506060830151848203606086015261356c8282612fb0565b91505060808301518482036080860152613586828261340a565b91505060a083015184820360a08601526135a08282613113565b91505060c083015184820360c08601526135ba8282613009565b91505060e08301516135cf60e0860182613a37565b506101008301516135e4610100860182613a37565b506101208301516135f9610120860182613a37565b5061014083015161360e610140860182613a37565b50610160830151613623610160860182613a37565b50610180830151613638610180860182613458565b506101a08301516135116101a0860182613458565b8051608083019061365e8482613a37565b5060208201516136716020850182613458565b5060408201516136846040850182613a49565b5060608201516136976060850182613a2e565b50505050565b80516000906101a08401906136b28582613a37565b5060208301516136c56020860182612fa7565b5060408301516136d86040860182613a37565b50606083015184820360608601526136f08282612fb0565b9150506080830151848203608086015261370a828261340a565b91505060a083015184820360a08601526137248282613113565b91505060c083015184820360c086015261373e8282613009565b91505060e083015161375360e0860182613a37565b50610100830151613768610100860182613a37565b5061012083015161377d610120860182613a37565b50610140830151613792610140860182613a37565b506101608301516137a7610160860182613458565b50610180830151613511610180860182613458565b805160808301906137cd8482613a37565b5060208201516137e06020850182613458565b5060408201516136846040850182613458565b805160c08301906138048482612fa7565b5060208201516138176020850182613a37565b50604082015161382a6040850182613a37565b50606082015161383d6060850182613a37565b5060808201516138506080850182613a37565b5060a082015161369760a0850182613a37565b80516101c08301906138758482612fa7565b5060208201516138886020850182613a37565b50604082015161389b6040850182613a37565b5060608201516138ae6060850182613a37565b5060808201516138c16080850182613a37565b5060a08201516138d460a0850182613a37565b5060c08201516138e760c0850182613a37565b5060e08201516138fa60e0850182613a37565b5061010082015161390f610100850182613a37565b50610120820151613924610120850182613458565b50610140820151613939610140850182613a37565b5061016082015161394e610160850182612fa7565b50610180820151613963610180850182613a37565b506101a08201516136976101a0850182613a37565b805160408301906139898482612fa7565b5060208201516136976020850182613a37565b805160808301906139ad8482613a37565b5060208201516139c06020850182613a37565b5060408201516139d36040850182612fa7565b5060608201516136976060850182613a37565b805160608301906139f78482613a37565b506020820151613a0a6020850182613a37565b5060408201516136976040850182612fa7565b805160408301906139898482613a37565b612fa181613c7a565b612fa181613c92565b612fa181613caf565b612fa181613c9e565b600061048482846134a2565b6020810161031e8284612fa7565b6020810161031e8284612f98565b60408101613a888285612f98565b6104846020830184612fa7565b60408101613aa38285612fa7565b81810360208301526129458184613077565b60408101613ac38285612fa7565b6104846020830184613a40565b602080825281016104848184613174565b6020808252810161048481846131d5565b602080825281016104848184613223565b602080825281016104848184613284565b6020808252810161048481846132d2565b602080825281016104848184613320565b60208082528101610484818461336e565b6020808252810161048481846133bc565b6020810161031e8284613499565b6020808252810161048481846134d1565b60c0810161031e82846137f3565b6101c0810161031e8284613863565b6040810161031e8284613978565b6080810161031e828461399c565b6060810161031e82846139e6565b6020810161031e8284613a37565b60408101613a888285613a37565b6040518181016001600160401b0381118282101715613bf857600080fd5b604052919050565b60006001600160401b03821115613c1657600080fd5b5060209081020190565b60006001600160401b03821115613c3657600080fd5b506020601f91909101601f19160190565b60200190565b5190565b90815260200190565b919050565b600061031e82613c86565b151590565b600061031e82613c5f565b6001600160801b031690565b6001600160a01b031690565b90565b63ffffffff1690565b60ff1690565b600061031e82613c6f565b600061031e82613c95565b60005b83811015613cd5578181015183820152602001613cbd565b838111156136975750506000910152565b601f01601f191690565b613cf981613c5f565b8114613d0457600080fd5b50565b613cf981613c6a565b613cf981613c6f565b613cf981613c7a565b613cf981613c92565b613cf981613c95565b613cf981613c9e56fea365627a7a72315820bad6a38ee0bb2e8d53b1098d3097e66acebff1efe7afa4a64184563c44bf9eb46c6578706572696d656e74616cf564736f6c63430005100040";
class TectonicLensFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicLensFactory = TectonicLensFactory;
TectonicLensFactory.bytecode = _bytecode;
TectonicLensFactory.abi = _abi;
//# sourceMappingURL=TectonicLensFactory.js.map